import { forwardRef } from 'react';

import { Text as NbText } from 'native-base';

import { addWithConfig } from '../../utils';

import { omitMaxFontSizeMultiplierOnWeb } from './platform-text-props';
import type { TextProps } from './types';

/** @deprecated nativebase component deprecated, use `<Typography />` instead */
export const Text = forwardRef((props: TextProps, ref) => {
  const resolvedProps = omitMaxFontSizeMultiplierOnWeb(props);

  return <NbText ref={ref} variant="copyOne" {...resolvedProps} />;
});

/** @deprecated nativebase component deprecated, use `<Typography />` instead */
export default addWithConfig(Text);
